import { post, get } from '@/utils/request';

export const postAbRouter = data => post('ab/router/v1', data);

